import { Form, Input, message, Modal } from 'antd'
import { addDays, differenceInDays } from 'date-fns'
import { enUS, ru } from 'date-fns/locale'
import React, { useState } from 'react'
import { DateRange } from 'react-date-range'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import { useTranslation } from 'react-i18next'
import api from '../../../../shared/api/api'
import background from '../../../../shared/assets/background.png'
import { LangSwitcher } from '../../../../shared/ui/LangSwitcher/LangSwitcher'
import cls from './HeroSection.module.scss'

const DAILY_PRICE = 90
const DEPOSIT = 300

const HeroSection: React.FC = () => {
    const { t, i18n } = useTranslation()

    const currentLocale = i18n.language === 'ru' ? ru : enUS

    const [isModalOpen, setIsModalOpen] = useState(false)
    const [form] = Form.useForm()
    const [price, setPrice] = useState<number | null>(null)
    const [range, setRange] = useState([
        {
            startDate: new Date(),
            endDate: addDays(new Date(), 2),
            key: 'selection'
        }
    ])

    const handleOpen = () => setIsModalOpen(true)

    const handleCancel = () => {
        setIsModalOpen(false)
        setPrice(null)
        form.resetFields()
    }
    console.log(price)

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields()
            const start = range[0].startDate
            const end = range[0].endDate

            const days = differenceInDays(end!, start!)

            if (days < 3) {
                message.warning(t('hero.min3Days'))
                return
            }

            const totalPrice = days * DAILY_PRICE + DEPOSIT
            setPrice(totalPrice)

            const payload = {
                startDate: start.toLocaleDateString('ru-RU'),
                endDate: end.toLocaleDateString('ru-RU'),
                contact: values.contact,
                comment: values.comment,
                price: totalPrice
            }

            await api.post('/vanlife', payload)
            message.success(t('hero.successMessage'))
            setIsModalOpen(false)
            setPrice(null)
            form.resetFields()
        } catch (error) {
            console.error(error)
            message.error(t('hero.errorMessage'))
        }
    }

    return (
        <section
            style={{
                height: '100vh',
                backgroundImage: `url(${background})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                position: 'relative',
                color: '#fff',
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column'
            }}
        >
            <div className={cls.overlay} />
            <div
                style={{
                    position: 'absolute',
                    top: 20,
                    right: 20,
                    zIndex: 999
                }}
            >
                <LangSwitcher />
            </div>
            <div className={cls.content}>
                <h1
                    style={{ fontSize: '3rem', maxWidth: 800, lineHeight: 1.2 }}
                >
                    {t('hero.title')}
                </h1>
                <p style={{ fontSize: '1.5rem', marginTop: '1rem' }}>
                    {t('hero.subtitle')}
                </p>
                <button
                    onClick={handleOpen}
                    style={{
                        marginTop: '2rem',
                        padding: '1rem 2rem',
                        backgroundColor: '#2971f5',
                        color: '#fff',
                        borderRadius: '30px',
                        textDecoration: 'none',
                        fontWeight: 'bold',
                        border: 'none',
                        cursor: 'pointer'
                    }}
                >
                    {t('hero.button')}
                </button>
            </div>

            <Modal
                style={{ top: 10 }}
                centered={false}
                title={t('hero.modalTitle')}
                open={isModalOpen}
                onCancel={handleCancel}
                onOk={handleSubmit}
                okText={t('hero.submit')}
                cancelText={t('hero.cancel')}
                width={370}
            >
                <Form layout="vertical" form={form} size="small">
                    <Form.Item
                        label={t('hero.dateRange')}
                        style={{ marginBottom: 3 }}
                    >
                        <DateRange
                            className={cls.dateRange}
                            showDateDisplay={false}
                            locale={currentLocale}
                            editableDateInputs={false}
                            onChange={(item: any) => {
                                setRange([item.selection])
                                const days = differenceInDays(
                                    item.selection.endDate!,
                                    item.selection.startDate!
                                )
                                if (days >= 3) {
                                    setPrice(days * DAILY_PRICE + DEPOSIT)
                                } else {
                                    setPrice(null)
                                }
                            }}
                            scroll={{
                                enabled: true
                            }}
                            moveRangeOnFirstSelection={false}
                            ranges={range}
                            minDate={new Date()}
                        />
                    </Form.Item>

                    {/* {price !== null && (
                        <Text
                            type="secondary"
                            style={{ display: 'block', marginBottom: 16 }}
                        >
                            {t('hero.totalPrice')}: <strong>${price}</strong> (
                            {t('hero.depositIncluded')})
                        </Text>
                    )} */}

                    <Form.Item
                        style={{ marginBottom: 5 }}
                        name="contact"
                        label={t('hero.contact')}
                        rules={[
                            {
                                required: true,
                                message: t('hero.contactRequired')
                            }
                        ]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="comment"
                        label={t('hero.comment')}
                        style={{ marginBottom: 5 }}
                    >
                        <Input.TextArea rows={3} />
                    </Form.Item>
                </Form>
            </Modal>
        </section>
    )
}

export default HeroSection
